/** TYPES **/
export const filesTypes = {
  UPLOAD_FILE: 'UPLOAD_FILE',
  UPLOAD_FILES: 'UPLOAD_FILES',
  DOWNLOAD_FILE: 'DOWNLOAD_FILE',
  GET_PDF: 'GET_PDF',
  SET_PDF: 'SET_PDF'
}

export interface FilesState {
  pdfUrl: string
}

/** ACTIONS **/
export interface UploadFileAction {
  type: typeof filesTypes.UPLOAD_FILE
  payload: File
  callback: (succ: boolean, fileName?: string) => void
  [key: string]: unknown
}

export interface UploadFilesAction {
  type: typeof filesTypes.UPLOAD_FILES
  payload: File[]
  callback: (succ: boolean, fileNameList?: string[]) => void
  [key: string]: unknown
}

export interface DownloadFileAction {
  type: typeof filesTypes.DOWNLOAD_FILE
  payload: DownloadFilePayload
  callback: (succ: boolean) => void
  [key: string]: unknown
}

export interface GetPDFAction {
  type: typeof filesTypes.GET_PDF
  payload: string
  callback: (succ: boolean) => void
  [key: string]: unknown
}

export interface SetPDFAction {
  type: typeof filesTypes.SET_PDF
  payload: string
  [key: string]: unknown
}

export interface DownloadFilePayload {
  documentType: "WORK_ORDER" | "ESTIMATE" | "JOB" | "INVOICE" | "WORK_ORDER_PRO_APP"
  resourceId: string
  parameters: {
    hidePricing?: boolean
    hideBefore?: boolean
    hideAfter?: boolean
    hideRepairNotes?: boolean
    hideInspectionNotes?: boolean
    hidePhotoNotes?: boolean
    groupBy?: "CATEGORY" | "PRIORITY" | "STATUS"
    hideItems?: boolean
    onlyApproved?: boolean
  }
}

export interface FilesType {
  pdfUrl: string
}

export type FilesActions =
  | UploadFileAction
  | UploadFilesAction
  | DownloadFileAction
  | GetPDFAction
  | SetPDFAction